export default "__VITE_ASSET__vA4KaGWH__"